export type RouteAuthMode =
  | "public"
  | "external_id"
  | "space"
  | "tenant"
  | "sso"
  | "connected_app";

export const ROUTE_AUTH_MODES: RouteAuthMode[] = [
  "public",
  "external_id",
  "tenant",
  "sso",
  "connected_app",
  "space",
];

export const ROUTE_AUTH_LABELS: Record<RouteAuthMode, string> = {
  public: "Public",
  external_id: "External ID",
  tenant: "Tenant",
  sso: "SSO",
  connected_app: "Connector",
  space: "Space",
};

export const ROUTE_AUTH_COLORS: Record<RouteAuthMode, string> = {
  public: "var(--red-600)",
  external_id: "var(--yellow-600)",
  tenant: "var(--sky-600)",
  sso: "var(--purple-600)",
  connected_app: "var(--teal-600)",
  space: "var(--green-600)",
};

export function routeAuthLabel(mode: RouteAuthMode): string {
  return ROUTE_AUTH_LABELS[mode];
}
